import React from "react";
import { useState } from "react";
// const AffectedItems = ({ records, options, label }) => {
const Remind = React.forwardRef((props, ref) => {
  const {
    containerCls = "",
    inputProps = {},
    label,
    name,
    records,
    options,
    primaryLabel,
    error,
    baseinfo,
    formInput,
    defaultValue,
  } = props;
  const [remainder, setRemainder] = useState(false);
  const onChangeHandler = (e) => {
    if (e.target.checked) {
      setRemainder(true);
    } else {
      setRemainder(false);
    }
  };
  return (
    <div>
      <hr />
      {label ? (
        <div className={`my-10 }`}>
          <div className="pb-1 text-gray-800">{primaryLabel}</div>
        </div>
      ) : null}
      {label ? (
        <div className={`my-1 }`}>
          <input type="checkbox" onChange={onChangeHandler} />
          <span className="pb-1 my-4 text-gray-800 incident_checkbox">
            {label}
          </span>
        </div>
      ) : null}
      {remainder && (
        <div className={`my-8 incident_checkbox}`}>
          <input type="radio" checked />
          <span className="pb-1 text-gray-800 incident_checkbox">Default</span>
        </div>
      )}
    </div>
  );
});
export default Remind;
